import React from 'react';
import './PointMode.css';

export interface BigGridProps {
  activePestId: string;
  cellState: (point: number, pestId: string) => 'empty' | 'clean' | 'infested';
  currentPoint: number;
  photos: Set<number>;
  gridMode: 'solo' | 'all';
  /** When provided and truthy for point i (and cell isn't itself infested), adds faint red */
  allInfestedAt?: (i: number) => boolean;
  onPickPoint: (i: number) => void;
}

const TOTAL = 100;

export function BigGrid({
  activePestId,
  cellState,
  currentPoint,
  photos,
  gridMode,
  allInfestedAt,
  onPickPoint,
}: BigGridProps) {
  const cells: React.ReactNode[] = [];

  for (let i = 0; i < TOTAL; i++) {
    const state = cellState(i, activePestId);

    const classes: string[] = ['biggrid__cell'];

    if (state === 'infested') {
      classes.push('biggrid__cell--red');
    } else if (state === 'clean') {
      if (gridMode === 'all' && allInfestedAt && allInfestedAt(i)) {
        classes.push('biggrid__cell--faint');
      } else {
        classes.push('biggrid__cell--clean');
      }
    }
    // empty → default grey (no extra class)

    if (i === currentPoint) {
      classes.push('biggrid__cell--cur');
    }

    if (photos.has(i)) {
      classes.push('biggrid__cell--photo');
    }

    cells.push(
      <div
        key={i}
        className={classes.join(' ')}
        data-testid={`grid-cell-${i}`}
        onClick={() => onPickPoint(i)}
        role="button"
        aria-label={`Point ${i + 1}`}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onPickPoint(i);
          }
        }}
      />
    );
  }

  return <div className="biggrid">{cells}</div>;
}

export default BigGrid;
